import React from "react";

import { twMerge } from "tailwind-merge";

export const Headline5: React.FC<React.ComponentProps<"h5">> = ({
  children,
  className,
  ...props
}) => {
  return (
    <h5
      className={twMerge(
        `text-sm font-semibold tracking-tight text-gray-900`,
        className,
      )}
      {...props}
    >
      {children}
    </h5>
  );
};
